import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { authReducer } from "./authReducer";
import { surveyReducer } from "./surveyReducer";
import { variableReducer } from "./variableReducer";
import { variableValueReducer } from "./variableValueReducer";
import { urlReducer } from "./urlReducer";
import { permissionsReducer } from "./permissionsReducer";
import { qnaBuilderReducer } from "./qnaBuilderReducer";
import { reportReducer } from "./reportReducer";
import { formBuilder } from "./formBuilderReducer";
import { analyticsReducer } from "./analyticsReducer";
import { roleReducer } from "./roleReducer";
import { teamReducer } from "./teamReducer";
import { userReducer } from "./userReducer";
import { locationReducer } from "./locationReducer";
import { loginUserReducer } from "./loginUserReducer";
import { commonKnowledgeReducer } from "./commonKnowledgeReducer";
import { promptsReducer } from "./promptsReducer";
import { leadIndicatorReducer } from './leadIndicatorReducer';
import { stagesReducer } from "./stagesReducer";
import { assistantsReducer } from "./assistantsReducer";
import { videoScriptReducer } from "./videoScriptReducer";
import { settingReducer } from "./settingReducer";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["permissionsData", "reportData"],
};

const tmpRootReducer = combineReducers({
  permissionsData: permissionsReducer,
  authData: authReducer,
  surveyData: surveyReducer,
  roleData: roleReducer,
  teamData: teamReducer,
  userData: userReducer,
  variables: variableReducer,
  variableValue: variableValueReducer,
  urlData: urlReducer,
  qnaData: qnaBuilderReducer,
  reportData: reportReducer,
  formBuilderData: formBuilder,
  analyticsData: analyticsReducer,
  locationData: locationReducer,
  userDataHeader: loginUserReducer,
  commonKnowledgeData: commonKnowledgeReducer,
  prompts: promptsReducer,
  leadIndicator: leadIndicatorReducer,
  stages: stagesReducer,
  assistants: assistantsReducer,
  videoScript: videoScriptReducer,
  settingData : settingReducer,
});

const rootReducer = persistReducer(persistConfig, tmpRootReducer);

export { rootReducer };
